<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row settings-parking-pass">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsParkingPassesService.showDetailedView"
         [ngStyle]="{width: settingsParkingPassesService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-9">
                    <filter [tabHeading]="getActiveTabTitle()"
                            [buildings]="settingsParkingPassesService.buildingsForRead">
                    </filter>
                </div>

                <div *ngIf="settingsParkingPassesService.canEdit()" class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="settingsParkingPassesService.showCreateModal = true">
                        <i class="fa fa-plus-circle"></i> New {{getActiveTabTitle()}}
                    </button>
                </div>

            </div>
            <div class="flex-fill" [ngClass]="{'sk-loading':spinnerShow}">
                <tabs-wrapper>
                    <tab-item title="Parking Rules" [tabId]="'rules'">
                        <settings-parking-passes-rules-list *ngIf="currentTabId == 'rules'"></settings-parking-passes-rules-list>
                    </tab-item>
                    <tab-item title="Parking Lots" [tabId]="'lots'">
                        <settings-parking-passes-lots-list *ngIf="currentTabId == 'lots'"></settings-parking-passes-lots-list>
                    </tab-item>
                    <pagination *ngIf="currentTabId && settingsParkingPassesService.parkingPassesData[currentTabId].total && urlService.queryParams['page']"
                                [total]="settingsParkingPassesService.parkingPassesData[currentTabId].total">
                    </pagination>
                    <spinner [spinnerShow]="spinnerShow"></spinner>
                </tabs-wrapper>
            </div>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
        <settings-parking-passes-detailed-view></settings-parking-passes-detailed-view>
    </div>
</div>

<div *ngIf="settingsParkingPassesService.showCreateModal">
    <settings-parking-lot-modal *ngIf="currentTabId == 'lots'"></settings-parking-lot-modal>
    <settings-parking-rules-modal *ngIf="currentTabId == 'rules'"></settings-parking-rules-modal>
</div>
<pass-type-modal *ngIf="settingsParkingPassesService.isPassTypeModalShow"></pass-type-modal>
<legal-agreement-modal *ngIf="settingsParkingPassesService.isLegalAgreementModalShow"></legal-agreement-modal>
<!--<disabled-dates-modal *ngIf="settingsParkingPassesService.isDisabledDatesModalShow"></disabled-dates-modal>-->
<pass-notification-modal *ngIf="settingsParkingPassesService.isPassNotificationModalShow"></pass-notification-modal>
<disclaimer-modal *ngIf="settingsParkingPassesService.isDisclaimerModalShow"></disclaimer-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes.component.html